module.exports = __webpack_public_path__ + "static/gptw-badge-47994731e96052a92e0da74b20cc9de9.png";